import React, { Component, ReactChildren, MouseEvent, ReactChild } from "react";
import { createPortal } from "react-dom";
import cx from "classnames";

const modalRoot = document.getElementById("modal-root");

type Props = {
	title: string;
	largeTitle?: Boolean;
	fullHeight?: Boolean;
	children: ReactChildren | ReactChild | Element | Element[] | JSX.Element | JSX.Element[];
	className?: string;
	onBackClicked?: (event: MouseEvent<HTMLElement>) => void;
	onCloseClicked: (event: MouseEvent<HTMLElement>) => void;
	onInfoClicked?: (event: MouseEvent<HTMLElement>) => void;
	onAddClicked?: (event: MouseEvent<HTMLElement>) => void;
};

export default class Modal extends Component<Props> {
	el = null as HTMLElement;

	constructor(props) {
		super(props);
		this.el = document.createElement("div");
	}

	componentDidMount() {
		modalRoot.appendChild(this.el);
	}

	componentWillUnmount() {
		modalRoot.removeChild(this.el);
	}

	getBackAction() {
		if (!this.props?.onBackClicked) {
			return null;
		}

		return (event: MouseEvent<HTMLElement>) => {
			this.props.onCloseClicked(event);
			this.props.onBackClicked?.(event);
		};
	}

	getInfoAction() {
		if (!this.props?.onInfoClicked) {
			return null;
		}

		return (event: MouseEvent<HTMLElement>) => {
			this.props.onCloseClicked(event);
			this.props.onInfoClicked?.(event);
		};
	}

	getAddAction() {
		if (!this.props?.onAddClicked) {
			return null;
		}

		return (event: MouseEvent<HTMLElement>) => {
			this.props.onCloseClicked(event);
			this.props.onAddClicked?.(event);
		};
	}

	render() {
		const [backFunction, infoFunction, addFunction] = [
			this.getBackAction(),
			this.getInfoAction(),
			this.getAddAction(),
		];

		return createPortal(
			[
				<div className={cx("modal", this.props.className)} key="modal">
					<div className={cx("modalDialog", { fullHeight: this.props.fullHeight })}>
						<div className={cx("modalHeader", { largeTitle: this.props.largeTitle })}>
							<div className="modalNavBarActions">
								{ backFunction && <div className="icon back" onClick={(event) => backFunction(event)} /> }
								{ this.props.largeTitle ? "" : <div className="modalTitle">{this.props.title}</div> }
								<div className="actions">
									{ addFunction && <div className="add" onClick={(event) => addFunction(event)} /> }
									{ infoFunction && <div className="info" onClick={(event) => infoFunction(event)} /> }
									<div className="close" onClick={this.props.onCloseClicked} />
								</div>
							</div>
							{this.props.largeTitle && <div className="modalLargeTitle">{this.props.title}</div>}
						</div>
						<div className="modalBody">{this.props.children}</div>
					</div>
					{addFunction && <div className="icon plus" onClick={() => addFunction} />}
					{infoFunction && <div className="icon info" onClick={() => infoFunction} />}
					<div className="overlay" key="overlay" onClick={this.props.onCloseClicked} />
				</div>,
			],
			this.el
		);
	}
}
